import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'templateModule',
  props: {
    source: String,
    templateList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showHandle: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    rename: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    handleList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    changeName: function changeName(item) {
      var _this = this;
      var _item$name = item.name,
        name = _item$name === void 0 ? '' : _item$name;
      this.$prompt('', '更新模板名称', {
        confirmButtonText: '完成',
        cancelButtonText: '取消',
        inputPattern: /^.{1,15}$/,
        inputErrorMessage: '模板名称为1-15个字',
        inputValue: name
      }).then(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref) {
          var value;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                value = _ref.value;
                _this.$emit('changeName', {
                  item: item,
                  value: value
                });
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function () {});
    },
    selectTemp: function selectTemp(item) {
      this.$emit('selectTemp', item);
    },
    chooseToPlatform: function chooseToPlatform(item) {
      this.$emit('chooseToPlatform', item);
    }
  }
};